/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Row_Export_HintInputs */

const en_us2_history_transfer_row_export_hint = /** @type {(inputs: History_Transfer_Row_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong's columns, every set you logged`)
};

const pt_br2_history_transfer_row_export_hint = /** @type {(inputs: History_Transfer_Row_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nas colunas do Strong, cada série registrada`)
};

const es_419_history_transfer_row_export_hint = /** @type {(inputs: History_Transfer_Row_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con las columnas de Strong, cada serie registrada`)
};

const pt_pt2_history_transfer_row_export_hint = /** @type {(inputs: History_Transfer_Row_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nas colunas do Strong, cada série registada`)
};

const fr_fr2_history_transfer_row_export_hint = /** @type {(inputs: History_Transfer_Row_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colonnes de Strong, chaque série enregistrée`)
};

const de_de2_history_transfer_row_export_hint = /** @type {(inputs: History_Transfer_Row_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In den Spalten von Strong, jeder erfasste Satz`)
};

const it_it2_history_transfer_row_export_hint = /** @type {(inputs: History_Transfer_Row_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con le colonne di Strong, ogni serie registrata`)
};

/**
* | output |
* | --- |
* | "Strong's columns, every set you logged" |
*
* @param {History_Transfer_Row_Export_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_row_export_hint = /** @type {((inputs?: History_Transfer_Row_Export_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Row_Export_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_row_export_hint(inputs)
	if (locale === "es-419") return es_419_history_transfer_row_export_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_row_export_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_row_export_hint(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_row_export_hint(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_row_export_hint(inputs)
	return en_us2_history_transfer_row_export_hint(inputs)
});
export { history_transfer_row_export_hint as "history-transfer.row_export_hint" }